(function () {
  const app = document.getElementById('loyalty-app');
  if (!app) return;

  const API = app.dataset.apiUrl;
  const SB_URL = app.dataset.sbUrl;
  const SB_KEY = app.dataset.sbKey;
  const HISTORY_MEDIA = {
    welcome: app.dataset.imgLogo,
    birthday: app.dataset.imgLogo,
    purchase: app.dataset.imgLogo,
    video_review: app.dataset.imgLogo,
    follow_instagram: app.dataset.imgInstagram,
    instagram_post: app.dataset.imgInstagram,
    share_story: app.dataset.imgInstagram,
    reel_unboxing: app.dataset.imgInstagram,
    follow_tiktok: app.dataset.imgTiktok,
    publish_tiktok: app.dataset.imgTiktok,
    google_review: app.dataset.imgGoogle,
    trustpilot_review: app.dataset.imgTrust,
  };
  const customerId = app.dataset.customerId;
  const email = app.dataset.customerEmail;
  const firstName = app.dataset.customerFirstName;
  const lastName = app.dataset.customerLastName;
  const loyaltyToken = app.dataset.loyaltyToken || '';
  const loyaltyTs    = app.dataset.loyaltyTs    || '';
  const POPUP_ATTRIBUTION_KEY = 'eut_popup_clicked';
  const POPUP_SESSION_KEY = 'eut_popup_sid';

  const TIER_CONFIG = {
    bronze:   { label: 'Bronze',   min: 0,    next: 150,  multiplier: 1.0, color: '#cd7f32' },
    silver:   { label: 'Silver',   min: 150,  next: 400,  multiplier: 1.2, color: '#a8a9ad' },
    gold:     { label: 'Gold',     min: 400,  next: 800,  multiplier: 1.4, color: '#d4af37' },
    platinum: { label: 'Platinum', min: 800,  next: 1500, multiplier: 1.7, color: '#b0c4d8' },
    diamond:  { label: 'Diamond',  min: 1500, next: null, multiplier: 2.0, color: '#7dd6e8' },
  };

  const REASON_META = {
    purchase:          { label: 'Commande',          icon: '🛍️', color: '#e8f5e9' },
    follow_instagram:  { label: 'Follow Instagram',  icon: '📸', color: '#fce4ec' },
    follow_tiktok:     { label: 'Follow TikTok',     icon: '🎵', color: '#ede7f6' },
    publish_tiktok:    { label: 'Vidéo TikTok',      icon: '🎵', color: '#ede7f6' },
    reel_unboxing:     { label: 'Reel unboxing',     icon: '🎬', color: '#e3f2fd' },
    video_review:      { label: 'Avis vidéo',        icon: '🎥', color: '#e3f2fd' },
    instagram_post:    { label: 'Post Instagram',    icon: '📷', color: '#fce4ec' },
    google_review:     { label: 'Avis Google',       icon: '⭐', color: '#fff8e1' },
    trustpilot_review: { label: 'Avis Trustpilot',   icon: '✅', color: '#e8f5e9' },
    birthday:          { label: 'Anniversaire',      icon: '🎂', color: '#fce4ec' },
    share_story:       { label: 'Story Instagram',   icon: '📤', color: '#fce4ec' },
    welcome:           { label: 'Bienvenue',         icon: '🎉', color: '#fff3e0' },
    redeem:            { label: 'Récompense utilisée', icon: '🎁', color: '#f3e5f5' },
  };
  const REJECTED_ACTION_LABELS = {
    publish_tiktok: 'Vidéo TikTok',
    reel_unboxing: 'Reel unboxing',
    video_review: 'Avis vidéo',
    instagram_post: 'Post Instagram',
    google_review: 'Avis Google',
    trustpilot_review: 'Avis Trustpilot',
    share_story: 'Story Instagram',
  };
  const MAX_VIDEO_UPLOAD_BYTES = 25 * 1024 * 1024;
  const MAX_IMAGE_UPLOAD_BYTES = 10 * 1024 * 1024;

  async function apiFetch(path, options = {}) {
    const headers = {
      'Content-Type': 'application/json',
      ...(loyaltyToken ? { 'X-Loyalty-Token': loyaltyToken, 'X-Loyalty-Ts': loyaltyTs } : {}),
      ...(options.headers || {}),
    };
    const res = await fetch(API + path, { ...options, headers });
    return res;
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  const spinnerTimeout = setTimeout(() => {
    const loading = document.getElementById('loyalty-loading');
    if (loading && loading.style.display !== 'none') {
      loading.innerHTML = '<p style="font-family:\'Bricolage Grotesque\',sans-serif;font-size:0.9rem;color:#888;padding:20px 0">Une erreur est survenue. <a href="" style="color:#151515;text-decoration:underline">Réessayer</a></p>';
    }
  }, 10000);

  async function init() {
    let customer;
    const getRes = await apiFetch(`/api/customer?customer_id=${customerId}`);

    if (getRes.status === 404) {
      const cameFromPopup = localStorage.getItem(POPUP_ATTRIBUTION_KEY) === '1';
      await apiFetch('/api/customer', {
        method: 'POST',
        body: JSON.stringify({
          customer_id: customerId,
          email,
          first_name: firstName,
          last_name: lastName,
          popup_session_id: cameFromPopup ? localStorage.getItem(POPUP_SESSION_KEY) : null,
          popup_page_url: cameFromPopup ? location.pathname : null,
        }),
      });
      if (cameFromPopup) localStorage.removeItem(POPUP_ATTRIBUTION_KEY);
      await apiFetch('/api/action', {
        method: 'POST',
        body: JSON.stringify({ customer_id: customerId, action_type: 'welcome' }),
      });
    }

    const syncRes = await apiFetch('/api/sync-points', { method: 'POST', body: JSON.stringify({ customer_id: customerId }) });
    if (syncRes.ok) {
      const s = await syncRes.json();
      customer = { first_name: firstName, points: s.points, lifetime_points: s.lifetime_points || 0, tier: s.tier, multiplier: s.multiplier, next_tier: s.next_tier, next_tier_label: s.next_tier_label, next_tier_min: s.next_tier_min, points_to_next_tier: s.points_to_next_tier };
    } else {
      const data = await getRes.json().catch(() => ({}));
      customer = data;
    }

    clearTimeout(spinnerTimeout);
    render(customer);
    await captureReferralAttribution();
    await Promise.all([loadHistory(), loadPastRewards(), loadDoneActions(), loadRejectedActions(), loadReferralHistory()]);
  }

  const TIER_ORDER = ['bronze', 'silver', 'gold', 'platinum', 'diamond'];
  const TIER_SPARKLE_SVG = '<svg class="ltp-node__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59 113.4" aria-hidden="true"><path d="M29.5 113.4C27.7 61.5 26.3 58.8 0 55.3 26.2 51.8 27.7 49 29.5 0c1.8 48.9 3.3 51.8 29.5 55.3-26.3 3.5-27.7 6.2-29.5 58.1Z" fill="currentColor"/></svg>';
  const TIER_PERKS = {
    bronze:   { threshold: 'Dès l\'inscription',      perks: ['1 point par euro dépensé', 'Accès à toutes les récompenses', 'Bijou offert pour votre anniversaire'] },
    silver:   { threshold: 'Dès 150 points cumulés',  perks: ['1.2 point par euro dépensé', 'Accès prioritaire aux ventes privées', '+20 pts le jour de votre anniversaire'] },
    gold:     { threshold: 'Dès 400 points cumulés',  perks: ['1.4 point par euro dépensé', 'Livraison offerte dès 40€', '+30 pts anniversaire + code cadeau'] },
    platinum: { threshold: 'Dès 800 points cumulés',  perks: ['1.7 point par euro dépensé', 'Bijou offert pour votre anniversaire', 'Livraison offerte dès 25€'] },
    diamond:  { threshold: 'Dès 1500 points cumulés', perks: ['2 points par euro dépensé', 'Bijou premium offert en anniversaire', 'Livraison toujours offerte'] },
  };

  function renderTierProgress(customer) {
    const block = document.getElementById('loyalty-tier-progress');
    if (!block) return;

    const tier = customer.tier || 'bronze';
    const lifetimePoints = customer.lifetime_points || 0;
    const tierIndex = TIER_ORDER.indexOf(tier);
    const cfg = TIER_CONFIG[tier];
    const nextMin = cfg.next;
    const nextTierLabel = tierIndex < TIER_ORDER.length - 1 ? TIER_CONFIG[TIER_ORDER[tierIndex + 1]].label : '';
    const amountToNextTier = nextMin ? Math.max(0, Math.ceil(nextMin - lifetimePoints)) : 0;

    // Line fill: each tier = 25% segment, plus partial progress in current segment
    let fillPct;
    if (!nextMin) {
      fillPct = 100;
    } else {
      const segmentPct = tierIndex * 25;
      const range = nextMin - cfg.min;
      const done = Math.max(0, Math.min(lifetimePoints - cfg.min, range));
      const partialPct = (done / range) * 25;
      fillPct = segmentPct + partialPct;
    }

    const nodesHtml = TIER_ORDER.map((t, i) => {
      const c = TIER_CONFIG[t];
      const p = TIER_PERKS[t];
      const state = i < tierIndex ? 'done' : i === tierIndex ? 'active' : 'future';
      let labelHtml = `<span class="ltp-node__spacer"></span>`;
      if (state === 'active') {
        labelHtml = `<span class="ltp-node__current-label">Votre rang actuel</span>`;
      } else if (nextMin && i === tierIndex + 1) {
        labelHtml = `<span class="ltp-node__next-label">Encore <strong>${amountToNextTier} pts</strong><br>pour atteindre ${nextTierLabel}</span>`;
      }
      const perksHtml = p.perks.map((perk) => `<li>${perk}</li>`).join('');
      return `
        <div class="ltp-node ltp-node--${state} ltp-node--${t}" style="--tc:${c.color}">
          ${labelHtml}
          <div class="ltp-node__dot"></div>
          <div class="ltp-node__bubble">
            <p class="ltp-node__name">${TIER_SPARKLE_SVG}<span>${c.label}</span></p>
            <p class="ltp-node__threshold">${p.threshold}</p>
            <ul class="ltp-node__perk-list">${perksHtml}</ul>
          </div>
        </div>`;
    }).join('');

    block.innerHTML = `
      <div class="ltp-wrap">
        <div class="ltp-timeline-scroll">
          <div class="ltp-track" data-default-fill="${fillPct}">
            <div class="ltp-line-bg">
              <div class="ltp-line-fill" style="width:${fillPct}%"></div>
            </div>
            <div class="ltp-nodes">${nodesHtml}</div>
          </div>
        </div>
      </div>`;

    const lineFill = block.querySelector('.ltp-line-fill');
    const track = block.querySelector('.ltp-track');
    const lineBg = block.querySelector('.ltp-line-bg');
    const nodes = block.querySelectorAll('.ltp-node');
    if (!lineFill || !track || !lineBg || !nodes.length) return;

    const getNodeFillPct = (node) => {
      const dot = node.querySelector('.ltp-node__dot');
      if (!dot) return 0;
      const lineRect = lineBg.getBoundingClientRect();
      const dotRect = dot.getBoundingClientRect();
      const dotCenter = dotRect.left + (dotRect.width / 2);
      const pct = ((dotCenter - lineRect.left) / lineRect.width) * 100;
      return Math.max(0, Math.min(100, pct));
    };

    const defaultNode = nodes[Math.max(0, Math.min(tierIndex, nodes.length - 1))];
    const defaultFillPct = getNodeFillPct(defaultNode);
    const defaultTierColor = getComputedStyle(defaultNode).getPropertyValue('--tc').trim() || '#c58f4c';

    const setFillFromNode = (node) => {
      lineFill.style.width = `${getNodeFillPct(node)}%`;
      const tierColor = getComputedStyle(node).getPropertyValue('--tc').trim();
      if (tierColor) {
        lineFill.style.background = tierColor;
      }
    };

    const resetFill = () => {
      lineFill.style.width = `${defaultFillPct}%`;
      lineFill.style.background = defaultTierColor;
    };

    resetFill();

    nodes.forEach((node) => {
      node.addEventListener('mouseenter', () => {
        setFillFromNode(node);
      });
      node.addEventListener('mouseleave', resetFill);
      node.addEventListener('focusin', () => {
        setFillFromNode(node);
      });
      node.addEventListener('focusout', resetFill);
    });
  }

  function initCarouselGrid(gridId, arrowClass, cardSel) {
    const grid = document.getElementById(gridId);
    if (!grid) return;
    const wrap = grid.closest('[class*="carousel-wrap"]') || grid.parentElement;
    const prev = wrap.querySelector('.' + arrowClass + '--prev');
    const next = wrap.querySelector('.' + arrowClass + '--next');
    if (!prev || !next) return;
    const getCards = () => Array.from(grid.querySelectorAll(cardSel)).filter((card) => {
      return card.getClientRects().length > 0;
    });
    function update() {
      prev.classList.toggle(arrowClass + '--hidden', grid.scrollLeft <= 2);
      next.classList.toggle(arrowClass + '--hidden', grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 2);
    }
    function getClosestIndex() {
      const cards = getCards();
      if (!cards.length) return -1;
      const currentLeft = grid.scrollLeft;
      let closestIndex = 0;
      let minDelta = Math.abs(cards[0].offsetLeft - currentLeft);
      cards.forEach((card, index) => {
        const delta = Math.abs(card.offsetLeft - currentLeft);
        if (delta < minDelta) {
          minDelta = delta;
          closestIndex = index;
        }
      });
      return closestIndex;
    }
    function scrollToCard(index) {
      const cards = getCards();
      if (!cards.length) return;
      const safeIndex = Math.max(0, Math.min(index, cards.length - 1));
      grid.scrollTo({ left: cards[safeIndex].offsetLeft, behavior: 'smooth' });
    }
    grid.addEventListener('scroll', update, {passive: true});
    prev.addEventListener('click', () => {
      const index = getClosestIndex();
      if (index >= 0) scrollToCard(index - 1);
    });
    next.addEventListener('click', () => {
      const index = getClosestIndex();
      if (index >= 0) scrollToCard(index + 1);
    });
    window.addEventListener('resize', update);
    update();
  }

  function initConnectedMissions() {
    const ONE_CLICK = new Set(['welcome', 'birthday']);
    document.querySelectorAll('#bc-missions-grid .bc-earn-card[data-action-card]').forEach(card => {
      const action = card.dataset.actionCard;
      const label = ONE_CLICK.has(action) ? 'Valider' : 'Participer';
      const hover = document.createElement('div');
      hover.className = 'bc-earn-card__hover';
      const btn = document.createElement('button');
      btn.className = 'loyalty-hero-btn loyalty-hero-btn--primary bc-earn-card__btn';
      btn.dataset.action = action;
      btn.innerHTML = `<span data-content="${label}">${label}</span>`;
      hover.appendChild(btn);
      card.appendChild(hover);
      btn.addEventListener('click', e => {
        e.stopPropagation();
        if (MISSIONS[action]) MISSIONS[action](btn);
      });
    });

    document.querySelectorAll('#bc-missions-grid .bc-earn-card[data-action-link]').forEach(card => {
      if (card.querySelector('.bc-earn-card__hover')) return;
      const href = card.dataset.actionLink;
      if (!href) return;
      const hover = document.createElement('div');
      hover.className = 'bc-earn-card__hover';
      const link = document.createElement('a');
      link.className = 'loyalty-hero-btn loyalty-hero-btn--primary bc-earn-card__btn';
      link.href = href;
      link.innerHTML = '<span data-content="Découvrir">Découvrir</span>';
      hover.appendChild(link);
      card.appendChild(hover);
    });
  }

  function initConnectedRewards() {
    document.querySelectorAll('#bc-rewards-connected-grid .loyalty-reward-card--interactive').forEach(card => {
      if (card.querySelector('.bc-reward-card__hover')) return;
      const rewardId = card.dataset.rewardId;
      if (!rewardId) return;
      const hover = document.createElement('div');
      hover.className = 'bc-reward-card__hover';
      const btn = document.createElement('button');
      btn.className = 'loyalty-hero-btn loyalty-hero-btn--primary bc-reward-card__btn';
      btn.type = 'button';
      btn.innerHTML = '<span data-content="Échanger">Échanger</span>';
      hover.appendChild(btn);
      card.appendChild(hover);
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        card.querySelector('.loyalty-btn--redeem')?.click();
      });
    });
  }

  function render(customer) {
    console.log('Fidélité: Début du rendu pour', customer.first_name);
    document.getElementById('loyalty-loading').style.display = 'none';
    document.getElementById('loyalty-main').style.display = '';
    
    const firstNameEl = document.getElementById('loyalty-first-name');
    if (firstNameEl) firstNameEl.textContent = customer.first_name || '';
    
    const pointsEl = document.getElementById('loyalty-points');
    if (pointsEl) pointsEl.textContent = customer.points || 0;

    const cfg = TIER_CONFIG[customer.tier] || TIER_CONFIG.bronze;
    const tierBadge = document.getElementById('loyalty-tier-badge');
    if (tierBadge) {
      tierBadge.textContent = cfg.label;
      tierBadge.style.setProperty('--loyalty-tier-c', cfg.color);
    }
    document.querySelector('.loyalty-welcome')?.style.setProperty('--loyalty-tier-c', cfg.color);
    
    renderTierProgress(customer);

    // Affichage des sections connectées
    console.log('Fidélité: Affichage des sections connectées...');
    ['loyalty-missions', 'loyalty-rewards', 'loyalty-activities'].forEach(id => {
      const el = document.getElementById(id);
      if (el) {
        el.style.display = 'block';
        console.log('Fidélité: Section affichée:', id);
      }
    });
    
    // Affichage de tous les blocs avec la classe bc-connected-only (comme le parrainage)
    document.querySelectorAll('.bc-connected-only').forEach(el => {
      el.style.display = 'block';
      console.log('Fidélité: Bloc classe affiché:', el.className);
    });

    initConnectedMissions();
    initConnectedRewards();
    sortGridByPoints('bc-rewards-connected-grid');

    try {
      renderReferral(customer);
      console.log('Fidélité: Parrainage rendu avec succès');
    } catch (e) {
      console.error('Fidélité: Erreur rendu parrainage:', e);
    }

    // Init carousels after browser reflow so dimensions are correct
    requestAnimationFrame(() => {
      initCarouselGrid('bc-missions-grid', 'bc-earn__arrow', '.bc-earn-card');
      initCarouselGrid('bc-rewards-connected-grid', 'bc-rewards__arrow', '.bc-reward-card');
    });
  }

  function sortGridByPoints(gridId) {
    const grid = document.getElementById(gridId);
    if (!grid) return;
    const cards = Array.from(grid.children);
    cards.sort((a, b) => {
      const ptsA = parseInt((a.querySelector('.bc-reward-card__pts') || {}).textContent || '0');
      const ptsB = parseInt((b.querySelector('.bc-reward-card__pts') || {}).textContent || '0');
      return ptsA - ptsB;
    });
    cards.forEach(c => grid.appendChild(c));
  }

  function renderReferral(customer) {
    const referralLinkInput = document.getElementById('referral-link');
    if (!referralLinkInput) return;

    // Show section
    const referralSection = document.querySelector('.bc-referral');
    if (referralSection) referralSection.style.display = 'block';

    const shopUrl = window.location.origin;
    const cId = customer.shopify_customer_id || customer.customer_id || customer.id || customerId;
    const referralLink = `${shopUrl}?ref=${cId}`;
    referralLinkInput.value = referralLink;

    // Bouton Copier
    const copyBtn = document.getElementById('copy-referral');
    if (copyBtn) {
      copyBtn.onclick = () => {
        navigator.clipboard.writeText(referralLink).then(() => {
          const orig = copyBtn.textContent;
          copyBtn.textContent = 'Copié !';
          setTimeout(() => copyBtn.textContent = orig, 2000);
        });
      };
    }

    // Envoi Invitation Email
    const sendEmailBtn = document.getElementById('send-referral-email');
    const emailInput = document.getElementById('referral-friend-email');
    const emailMsg = document.getElementById('referral-email-msg');

    if (sendEmailBtn && emailInput) {
      sendEmailBtn.onclick = async () => {
        const friendEmail = emailInput.value.trim();
        if (!friendEmail || !friendEmail.includes('@')) {
          emailMsg.textContent = 'Veuillez entrer un e-mail valide.';
          emailMsg.className = 'bc-referral__msg error';
          return;
        }

        sendEmailBtn.disabled = true;
        const originalLabel = sendEmailBtn.textContent;
        sendEmailBtn.textContent = 'Envoi...';

        try {
          // On tente l'envoi via l'API
          const res = await fetch(`${API}/api/customer?mode=referral-invite`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              customer_id: cId,
              friend_email: friendEmail,
              referral_link: referralLink
            })
          });

          if (res.ok) {
            emailMsg.textContent = 'Invitation envoyée avec succès ! ✨';
            emailMsg.className = 'bc-referral__msg success';
            emailInput.value = '';
          } else {
            throw new Error();
          }
        } catch (e) {
          // Fallback : mailto si l'API échoue ou n'est pas en place
          const subject = encodeURIComponent('Je t\'offre 10€ chez Euteyia ✦');
          const body = encodeURIComponent(`Coucou ! Regarde ces bijoux chez Euteyia, je t'offre 10€ sur ta première commande avec mon lien : ${referralLink}`);
          window.location.href = `mailto:${friendEmail}?subject=${subject}&body=${body}`;

          emailMsg.textContent = 'Votre application e-mail va s\'ouvrir...';
          emailMsg.className = 'bc-referral__msg success';
        }

        setTimeout(() => {
          sendEmailBtn.disabled = false;
          sendEmailBtn.textContent = originalLabel;
        }, 2000);
      };
    }

    // Partage Réseaux
    const shareText = encodeURIComponent(`Coucou ! Regarde ces bijoux chez Euteyia, je t'offre 10€ sur ta première commande avec mon lien : ${referralLink}`);

    const whatsapp = document.getElementById('share-whatsapp');
    if (whatsapp) whatsapp.href = `https://wa.me/?text=${shareText}`;

    const messenger = document.getElementById('share-messenger');
    if (messenger) messenger.href = `fb-messenger://share/?link=${encodeURIComponent(referralLink)}`;
  }

  async function captureReferralAttribution() {
    const urlParams = new URLSearchParams(window.location.search);
    const refFromUrl = urlParams.get('ref');
    const storedRef = localStorage.getItem('euteyia_referral');
    const referrerCustomerId = refFromUrl || storedRef;

    if (!referrerCustomerId || !customerId || referrerCustomerId === customerId) return;

    try {
      const res = await apiFetch('/api/customer?mode=referral-track', {
        method: 'POST',
        body: JSON.stringify({
          customer_id: customerId,
          referrer_customer_id: referrerCustomerId,
        }),
      });

      if (res.ok) {
        const data = await res.json().catch(() => ({}));
        localStorage.removeItem('euteyia_referral');
        if (data?.new_reward && data.reward_code) {
          showMessageModal({
            icon: '✨',
            title: 'Parrainage enregistré',
            text: `Ton code de bienvenue 10€ a été créé : ${data.reward_code}`,
          });
        }
      }
    } catch (err) {
      console.error('Fidélité: impossible d’enregistrer le parrainage', err);
    }
  }

  async function loadReferralHistory() {
    const container = document.getElementById('referral-history');
    const wrapper = document.getElementById('referral-history-container');
    if (!container || !wrapper) return;

    const res = await apiFetch(`/api/customer?mode=referral-history&customer_id=${customerId}`);
    if (!res.ok) return;

    const items = await res.json();
    if (!items?.length) return;

    wrapper.style.display = 'block';
    container.innerHTML = items.map((item) => {
      const statusClass = item.rewarded ? 'completed' : 'pending';
      const statusLabel = item.rewarded ? 'Récompensée' : 'En attente de 1re commande';
      const name = item.name || item.email || `Cliente ${item.referred_customer_id}`;
      return `
        <article class="bc-referral-item">
          <div>
            <p class="bc-referral-item__email">${name}</p>
            ${item.email ? `<p class="bc-referral-item__meta">${item.email}</p>` : ''}
          </div>
          <span class="bc-referral-item__status bc-referral-item__status--${statusClass}">${statusLabel}</span>
        </article>`;
    }).join('');
  }


  async function refreshPoints() {
    const r = await apiFetch('/api/sync-points', { method: 'POST', body: JSON.stringify({ customer_id: customerId }) });
    if (r.ok) {
      const d = await r.json();
      document.getElementById('loyalty-points').textContent = d.points;
      const cfg = TIER_CONFIG[d.tier] || TIER_CONFIG.bronze;
      document.getElementById('loyalty-tier-badge').textContent = cfg.label;
    }
  }

  // ── History ───────────────────────────────────────────────────────────────
  async function loadHistory() {
    const res = await apiFetch(`/api/history?customer_id=${customerId}`);
    if (!res.ok) return;
    const items = await res.json();
    const list = document.getElementById('loyalty-history-list');
    const section = document.getElementById('loyalty-activities');
    if (!items?.length) return;
    if (section) section.style.display = '';
    list.innerHTML = items.map(item => {
      const meta = REASON_META[item.reason] || { label: item.reason, icon: '✦', color: '#f0f0f0' };
      const sign = item.points > 0 ? '+' : '';
      const cls = item.points > 0 ? 'positive' : 'negative';
      const dateLabel = new Date(item.created_at).toLocaleDateString('fr-FR');
      const mediaUrl = HISTORY_MEDIA[item.reason] || HISTORY_MEDIA.welcome;
      const mediaStyle = mediaUrl ? ` style="background-image:url('${mediaUrl}');"` : '';
      return `<div class="loyalty-history-item">
        <div class="loyalty-history-item__media"${mediaStyle}></div>
        <div class="loyalty-history-item__content">
          <div class="loyalty-history-item__reason">${meta.label}</div>
          <div class="loyalty-history-item__status"><span class="loyalty-history-item__status-check">✓</span>${item.points > 0 ? 'Mission validée' : 'Récompense utilisée'}</div>
          <div class="loyalty-history-item__date">${dateLabel}</div>
          <div class="loyalty-history-item__points loyalty-history-item__points--${cls}">${sign}${item.points} pts</div>
        </div>
      </div>`;
    }).join('');
  }

  // ── Past rewards ──────────────────────────────────────────────────────────
  async function loadPastRewards() {
    const res = await apiFetch(`/api/history?mode=rewards&customer_id=${customerId}`);
    if (!res.ok) return;
    const items = await res.json();
    const container = document.getElementById('loyalty-past-rewards');
    if (!items?.length) return;
    container.innerHTML = '<p style="font-size:0.85rem;color:#888;margin-bottom:8px">Codes déjà obtenus :</p>' +
      items.map(item => {
        const exp = item.expires_at ? ` · expire le ${new Date(item.expires_at).toLocaleDateString('fr-FR')}` : '';
        return `<div class="loyalty-past-reward-item">
          <span class="loyalty-past-reward-item__code">${item.discount_code}</span>
          <span class="loyalty-past-reward-item__used">${item.used ? 'Utilisé' : 'Disponible'}${exp}</span>
        </div>`;
      }).join('');
  }

  // ── Done actions ──────────────────────────────────────────────────────────
  async function loadDoneActions() {
    const res = await apiFetch(`/api/history?mode=done&customer_id=${customerId}`);
    if (!res.ok) return;
    const done = await res.json();
    done.forEach(action => {
      const card = document.querySelector(`[data-action-card="${action}"]`);
      if (card) card.style.display = 'none';
    });
  }

  async function loadRejectedActions() {
    const res = await apiFetch(`/api/history?mode=rejected&customer_id=${customerId}`);
    if (!res.ok) return;
    const items = await res.json();
    document.querySelectorAll('.loyalty-review-alert--inline').forEach((node) => node.remove());
    document.querySelectorAll('.loyalty-mission-stack').forEach((stack) => {
      const card = stack.querySelector('.bc-earn-card');
      if (card) {
        stack.parentNode.insertBefore(card, stack);
      }
      stack.remove();
    });

    if (!items?.length) return;

    items.forEach((item) => {
      const targetCard = document.querySelector(`#bc-missions-grid [data-action-card="${item.action_type}"]`);
      if (!targetCard || targetCard.style.display === 'none') return;

      const title = REJECTED_ACTION_LABELS[item.action_type] || item.action_type;
      const reviewedAt = item.reviewed_at || item.created_at;
      const dateLabel = reviewedAt ? new Date(reviewedAt).toLocaleDateString('fr-FR') : '';
      const reason = item.rejection_reason || 'Votre soumission doit être corrigée avant une nouvelle validation.';
      const alert = document.createElement('article');
      alert.className = 'loyalty-review-alert loyalty-review-alert--inline';
      alert.innerHTML = `
        <button type="button" class="loyalty-review-alert__close" aria-label="Fermer">×</button>
        <p class="loyalty-review-alert__eyebrow">Activité refusée</p>
        <h3 class="loyalty-review-alert__title">${title}</h3>
        <p class="loyalty-review-alert__text">${reason}</p>
        <p class="loyalty-review-alert__date">Refusée le ${dateLabel}. Vous pouvez corriger et renvoyer cette activité.</p>
      `;
      alert.querySelector('.loyalty-review-alert__close')?.addEventListener('click', () => alert.remove());
      const stack = document.createElement('div');
      stack.className = 'loyalty-mission-stack';
      targetCard.parentNode.insertBefore(stack, targetCard);
      stack.appendChild(targetCard);
      stack.appendChild(alert);
    });
  }

  // ── Upload to Supabase Storage ────────────────────────────────────────────
  async function uploadFile(file) {
    const ext = file.name.split('.').pop();
    const path = `${customerId}/${Date.now()}.${ext}`;
    const res = await fetch(`${SB_URL}/storage/v1/object/loyalty-uploads/${path}`, {
      method: 'POST',
      headers: { 'apikey': SB_KEY, 'Authorization': `Bearer ${SB_KEY}`, 'Content-Type': file.type },
      body: file,
    });
    if (!res.ok) {
      const errorText = await res.text();
      throw new Error(errorText || 'Upload échoué');
    }
    return `${SB_URL}/storage/v1/object/public/loyalty-uploads/${path}`;
  }

  // ── Action submit ─────────────────────────────────────────────────────────
  async function submitAction(action_type, extra = {}) {
    const res = await apiFetch('/api/action', {
      method: 'POST',
      body: JSON.stringify({ customer_id: customerId, action_type, ...extra }),
    });
    return res;
  }

  function isValidHttpUrl(value) {
    try {
      const url = new URL(value);
      return url.protocol === 'http:' || url.protocol === 'https:';
    } catch (_) {
      return false;
    }
  }

  function isSwissTransferUrl(value) {
    try {
      const host = new URL(value).hostname.replace(/^www\./, '');
      return host === 'swisstransfer.com';
    } catch (_) {
      return false;
    }
  }

  function getFileSizeMb(file) {
    return (file.size / (1024 * 1024)).toFixed(1);
  }

  function hideCard(btn) {
    const card = btn.closest('[data-action-card]');
    if (card) {
      card.style.transition = 'opacity 0.4s, transform 0.4s';
      card.style.opacity = '0';
      card.style.transform = 'scale(0.85)';
      setTimeout(() => card.remove(), 420);
    }
  }

  async function handleActionResult(res, btn) {
    const data = await res.json();
    if (res.ok || res.status === 409) {
      hideCard(btn);
      if (res.ok) await refreshPoints();
      await loadHistory();
      await loadDoneActions();
      await loadRejectedActions();
    } else {
      showMessageModal({ icon: '⚠️', title: 'Erreur', text: data.error || 'Une erreur est survenue.' });
      btn.textContent = 'Erreur';
      btn.disabled = false;
    }
  }

  // ── Modal factory ─────────────────────────────────────────────────────────
  function createModal(content) {
    const overlay = document.createElement('div');
    overlay.className = 'loyalty-modal-overlay';
    overlay.innerHTML = `<div class="loyalty-modal">${content}</div>`;
    document.body.appendChild(overlay);
    overlay.addEventListener('click', e => { if (e.target === overlay) overlay.remove(); });
    overlay.querySelector('.loyalty-modal__close')?.addEventListener('click', () => overlay.remove());
    return overlay;
  }

  function modalBase(icon, title, body) {
    return `<button class="loyalty-modal__close">✕</button>
      <div class="loyalty-modal__icon">${icon}</div>
      <h3 class="loyalty-modal__title">${title}</h3>
      ${body}`;
  }

  function showMessageModal({ icon = '✦', title = 'Information', text, buttonLabel = 'OK' }) {
    const overlay = createModal(modalBase(icon, title,
      `<p class="loyalty-modal__text">${text}</p>
      <button class="loyalty-btn loyalty-btn--mission loyalty-modal__validate">${buttonLabel}</button>`
    ));
    overlay.querySelector('.loyalty-modal__validate')?.addEventListener('click', () => overlay.remove());
    return overlay;
  }

  function showConfirmModal({ icon = '✦', title = 'Confirmation', text, confirmLabel = 'Confirmer', cancelLabel = 'Annuler' }) {
    return new Promise((resolve) => {
      const overlay = createModal(modalBase(icon, title,
        `<p class="loyalty-modal__text">${text}</p>
        <div class="loyalty-modal__actions" style="display:flex;gap:10px;justify-content:center">
          <button class="loyalty-btn loyalty-btn--secondary loyalty-modal__cancel">${cancelLabel}</button>
          <button class="loyalty-btn loyalty-btn--mission loyalty-modal__confirm">${confirmLabel}</button>
        </div>`
      ));

      const cleanup = (result) => {
        overlay.remove();
        resolve(result);
      };

      overlay.querySelector('.loyalty-modal__cancel')?.addEventListener('click', () => cleanup(false));
      overlay.querySelector('.loyalty-modal__confirm')?.addEventListener('click', () => cleanup(true));
      overlay.querySelector('.loyalty-modal__close')?.addEventListener('click', () => cleanup(false));
    });
  }

  // ── Missions config ───────────────────────────────────────────────────────
  const MISSIONS = {
    follow_instagram: (btn) => {
      const overlay = createModal(modalBase('📸', 'Suivre Euteyia sur Instagram',
        `<p class="loyalty-modal__text">Renseigne ton identifiant Instagram et assure-toi que ton compte est <strong>public</strong> avant de valider.</p>
        <div class="loyalty-modal__input-wrap"><input type="text" class="loyalty-modal__input" placeholder="@votre_instagram" /></div>
        <button class="loyalty-btn loyalty-btn--mission loyalty-modal__validate">Suivre sur Instagram → +50 pts</button>`
      ));
      const vBtn = overlay.querySelector('.loyalty-modal__validate');
      vBtn.addEventListener('click', () => {
        const handle = overlay.querySelector('.loyalty-modal__input').value.trim();
        if (!handle) { overlay.querySelector('.loyalty-modal__input').style.borderColor = 'red'; return; }
        window.open('https://www.instagram.com/euteyia/', '_blank');
        let t = 30;
        vBtn.disabled = true;
        vBtn.textContent = `Vérification... ${t}s`;
        const timer = setInterval(async () => {
          t--;
          vBtn.textContent = `Vérification... ${t}s`;
          if (t <= 0) {
            clearInterval(timer);
            overlay.remove();
            const res = await submitAction('follow_instagram', { handle });
            await handleActionResult(res, btn);
          }
        }, 1000);
      });
    },

    follow_tiktok: (btn) => {
      const overlay = createModal(modalBase('🎵', 'Suivre Euteyia sur TikTok',
        `<p class="loyalty-modal__text">Renseigne ton identifiant TikTok et assure-toi que ton compte est <strong>public</strong> avant de valider.</p>
        <div class="loyalty-modal__input-wrap"><input type="text" class="loyalty-modal__input" placeholder="@votre_tiktok" /></div>
        <button class="loyalty-btn loyalty-btn--mission loyalty-modal__validate">Suivre sur TikTok → +5 pts</button>`
      ));
      const vBtn = overlay.querySelector('.loyalty-modal__validate');
      vBtn.addEventListener('click', () => {
        const handle = overlay.querySelector('.loyalty-modal__input').value.trim();
        if (!handle) { overlay.querySelector('.loyalty-modal__input').style.borderColor = 'red'; return; }
        window.open('https://www.tiktok.com/@euteyia', '_blank');
        let t = 30;
        vBtn.disabled = true;
        vBtn.textContent = `Vérification... ${t}s`;
        const timer = setInterval(async () => {
          t--;
          vBtn.textContent = `Vérification... ${t}s`;
          if (t <= 0) {
            clearInterval(timer);
            overlay.remove();
            const res = await submitAction('follow_tiktok', { handle });
            await handleActionResult(res, btn);
          }
        }, 1000);
      });
    },

    publish_tiktok: (btn) => {
      const overlay = createModal(modalBase('🎵', 'Publier un TikTok',
        `<p class="loyalty-modal__text">Publiez une vidéo TikTok en mentionnant <strong>@euteyia</strong> pour gagner 250 points.</p>
        <div class="loyalty-modal__input-wrap">
          <input type="text" class="loyalty-modal__input" placeholder="@votre_tiktok" style="margin-bottom:8px" />
          <input type="text" class="loyalty-modal__input loyalty-modal__link" placeholder="Lien de votre TikTok" />
        </div>
        <label class="loyalty-modal__check"><input type="checkbox" class="loyalty-modal__checkbox" /> Je confirme être l'auteur du contenu</label>
        <button class="loyalty-btn loyalty-btn--mission loyalty-modal__validate" style="margin-top:12px">Valider ma mission → +250 pts</button>`
      ));
      overlay.querySelector('.loyalty-modal__validate').addEventListener('click', async () => {
        const handle = overlay.querySelector('.loyalty-modal__input').value.trim();
        const link = overlay.querySelector('.loyalty-modal__link').value.trim();
        const checked = overlay.querySelector('.loyalty-modal__checkbox').checked;
        if (!handle || !link || !checked) { showMessageModal({ icon: '⚠️', title: 'Champs requis', text: 'Merci de remplir tous les champs et cocher la case.' }); return; }
        if (!isValidHttpUrl(link)) { showMessageModal({ icon: '⚠️', title: 'Lien invalide', text: 'Merci de renseigner un lien TikTok valide commençant par http:// ou https://' }); return; }
        overlay.remove();
        const res = await submitAction('publish_tiktok', { handle, link });
        await handleActionResult(res, btn);
      });
    },

    reel_unboxing: (btn) => {
      const overlay = createModal(modalBase('🎬', 'Publier un Reel unboxing',
        `<p class="loyalty-modal__text"><strong>Instructions :</strong><br>
        Titre : <em>Unboxing ETA 🤍</em><br>
        Légende : Tous les bijoux sont sur le site de ETA @euteyia<br>
        Prérequis : ouvrir votre colis, montrer la boîte et les bijoux, zooms portés, ajouter du texte, ne pas porter d'autres marques.</p>
        <div class="loyalty-modal__input-wrap">
          <input type="text" class="loyalty-modal__input" placeholder="@votre_instagram" style="margin-bottom:8px" />
          <input type="text" class="loyalty-modal__link loyalty-modal__input" placeholder="Lien de votre Reel" />
        </div>
        <label class="loyalty-modal__check"><input type="checkbox" class="loyalty-modal__checkbox" /> Je confirme être l'auteur et cède les droits à Euteyia</label>
        <button class="loyalty-btn loyalty-btn--mission loyalty-modal__validate" style="margin-top:12px">Envoyer en validation → +40 pts</button>`
      ));
      overlay.querySelector('.loyalty-modal__validate').addEventListener('click', async () => {
        const handle = overlay.querySelector('.loyalty-modal__input').value.trim();
        const link = overlay.querySelector('.loyalty-modal__link').value.trim();
        const checked = overlay.querySelector('.loyalty-modal__checkbox').checked;
        if (!handle || !link || !checked) { showMessageModal({ icon: '⚠️', title: 'Champs requis', text: 'Merci de remplir tous les champs et cocher la case.' }); return; }
        if (!isValidHttpUrl(link)) { showMessageModal({ icon: '⚠️', title: 'Lien invalide', text: 'Merci de renseigner un lien Reel valide commençant par http:// ou https://' }); return; }
        overlay.remove();
        const res = await submitAction('reel_unboxing', { handle, link });
        await handleActionResult(res, btn);
      });
    },

    video_review: (btn) => {
      const overlay = createModal(modalBase('🎥', 'Avis vidéo sur ta commande',
        `<p class="loyalty-modal__text">Filme ton avis sur tes bijoux Euteyia (30s à 2 min, belle lumière, pas d'autres marques).<br><br>
        <strong>1.</strong> Uploade ta vidéo sur <a href="https://www.swisstransfer.com" target="_blank" style="color:#151515;font-weight:700;text-decoration:underline">SwissTransfer.com</a> (gratuit, sans compte, lien valable 30 jours)<br>
        <strong>2.</strong> Copie le lien de téléchargement et colle-le ici</p>
        <div class="loyalty-modal__input-wrap">
          <input type="text" class="loyalty-modal__input loyalty-modal__link" placeholder="https://www.swisstransfer.com/d/..." />
        </div>
        <label class="loyalty-modal__check"><input type="checkbox" class="loyalty-modal__checkbox" /> Je confirme être l'auteur·e et cède les droits à Euteyia</label>
        <button class="loyalty-btn loyalty-btn--mission loyalty-modal__validate" style="margin-top:12px">Envoyer mon avis vidéo → +30 pts</button>`
      ));
      overlay.querySelector('.loyalty-modal__validate').addEventListener('click', async () => {
        const link = overlay.querySelector('.loyalty-modal__link').value.trim();
        const checked = overlay.querySelector('.loyalty-modal__checkbox').checked;
        if (!link) { showMessageModal({ icon: '⚠️', title: 'Lien manquant', text: 'Merci de coller ton lien SwissTransfer.' }); return; }
        if (!isValidHttpUrl(link)) { showMessageModal({ icon: '⚠️', title: 'Lien invalide', text: 'Le lien doit commencer par https://' }); return; }
        if (!isSwissTransferUrl(link)) { showMessageModal({ icon: '⚠️', title: 'Lien SwissTransfer requis', text: 'Merci de coller un lien SwissTransfer valide.' }); return; }
        overlay.remove();
        const res = await submitAction('video_review', { link });
        await handleActionResult(res, btn);
      });
    },

    instagram_post: (btn) => {
      const overlay = createModal(modalBase('📷', 'Publier un post composition',
        `<p class="loyalty-modal__text">Publiez votre composition de bijoux sur Instagram. Identifiez <strong>@euteyia</strong>, ajoutez <strong>#euteyia</strong>, puis collez le lien du post ici. Ne pas porter des bijoux d'autres marques.</p>
        <div class="loyalty-modal__input-wrap">
          <input type="text" class="loyalty-modal__input" placeholder="@votre_instagram" style="margin-bottom:8px" />
          <input type="text" class="loyalty-modal__link loyalty-modal__input" placeholder="Lien de votre post Instagram" />
        </div>
        <label class="loyalty-modal__check"><input type="checkbox" class="loyalty-modal__checkbox" /> Je confirme être l'auteur et cède les droits à Euteyia</label>
        <button class="loyalty-btn loyalty-btn--mission loyalty-modal__validate" style="margin-top:12px">Envoyer mon post → +30 pts</button>`
      ));
      overlay.querySelector('.loyalty-modal__validate').addEventListener('click', async () => {
        const handle = overlay.querySelector('.loyalty-modal__input').value.trim();
        const link = overlay.querySelector('.loyalty-modal__link').value.trim();
        const checked = overlay.querySelector('.loyalty-modal__checkbox').checked;
        if (!handle || !link || !checked) { showMessageModal({ icon: '⚠️', title: 'Champs requis', text: 'Merci de remplir tous les champs et cocher la case.' }); return; }
        if (!isValidHttpUrl(link)) { showMessageModal({ icon: '⚠️', title: 'Lien invalide', text: 'Merci de renseigner un lien Instagram valide commençant par http:// ou https://' }); return; }
        overlay.remove();
        const res = await submitAction('instagram_post', { handle, link });
        await handleActionResult(res, btn);
      });
    },

    google_review: (btn) => {
      const overlay = createModal(modalBase('⭐', 'Laisser un avis Google',
        `<p class="loyalty-modal__text">Déposez un avis sur notre fiche Google, récupérez le lien de votre avis et collez-le ci-dessous.</p>
        <div class="loyalty-modal__input-wrap">
          <input type="text" class="loyalty-modal__input" placeholder="Lien de votre avis Google" />
        </div>
        <button class="loyalty-btn loyalty-btn--mission loyalty-modal__validate">Valider ma mission → +10 pts</button>`
      ));
      overlay.querySelector('.loyalty-modal__validate').addEventListener('click', async () => {
        const link = overlay.querySelector('.loyalty-modal__input').value.trim();
        if (!link) { overlay.querySelector('.loyalty-modal__input').style.borderColor = 'red'; return; }
        if (!isValidHttpUrl(link)) { showMessageModal({ icon: '⚠️', title: 'Lien invalide', text: 'Merci de renseigner un lien Google valide commençant par http:// ou https://' }); return; }
        overlay.remove();
        const res = await submitAction('google_review', { link });
        await handleActionResult(res, btn);
      });
    },

    trustpilot_review: (btn) => {
      const overlay = createModal(modalBase('⭐', 'Laisser un avis Trustpilot',
        `<p class="loyalty-modal__text">Déposez un avis sur notre fiche Trustpilot, puis collez le lien de votre avis ci-dessous.</p>
        <div class="loyalty-modal__input-wrap">
          <input type="text" class="loyalty-modal__input loyalty-modal__link" placeholder="Lien de votre avis Trustpilot" />
        </div>
        <button class="loyalty-btn loyalty-btn--mission loyalty-modal__validate">Envoyer mon avis → +10 pts</button>`
      ));
      overlay.querySelector('.loyalty-modal__validate').addEventListener('click', async () => {
        const link = overlay.querySelector('.loyalty-modal__link').value.trim();
        if (!link) { showMessageModal({ icon: '⚠️', title: 'Lien manquant', text: 'Merci de coller le lien de votre avis Trustpilot.' }); return; }
        if (!isValidHttpUrl(link)) { showMessageModal({ icon: '⚠️', title: 'Lien invalide', text: 'Merci de renseigner un lien Trustpilot valide commençant par http:// ou https://' }); return; }
        overlay.remove();
        const res = await submitAction('trustpilot_review', { link });
        await handleActionResult(res, btn);
      });
    },

    birthday: (btn) => {
      const overlay = createModal(modalBase('🎂', 'Votre date d\'anniversaire',
        `<p class="loyalty-modal__text">Renseignez votre date d'anniversaire et recevez 100 points chaque année !</p>
        <div class="loyalty-modal__input-wrap">
          <input type="date" class="loyalty-modal__input loyalty-modal__date" />
        </div>
        <button class="loyalty-btn loyalty-btn--mission loyalty-modal__validate">Valider → +10 pts</button>`
      ));
      overlay.querySelector('.loyalty-modal__validate').addEventListener('click', async () => {
        const birthday = overlay.querySelector('.loyalty-modal__date').value;
        if (!birthday) { overlay.querySelector('.loyalty-modal__date').style.borderColor = 'red'; return; }
        overlay.remove();
        const res = await submitAction('birthday', { birthday });
        await handleActionResult(res, btn);
      });
    },

    welcome: async (btn) => {
      const res = await submitAction('welcome');
      await handleActionResult(res, btn);
    },

    share_story: (btn) => {
      const overlay = createModal(modalBase('📤', 'Partager notre dernier post en story',
        `<p class="loyalty-modal__text">Allez sur notre compte Instagram <strong>@euteyia</strong>, partagez notre dernière publication en story, puis validez ci-dessous.</p>
        <div class="loyalty-modal__input-wrap">
          <input type="text" class="loyalty-modal__input" placeholder="@votre_instagram" />
        </div>
        <button class="loyalty-btn loyalty-btn--mission loyalty-modal__validate">J'ai partagé → +20 pts</button>`
      ));
      overlay.querySelector('.loyalty-modal__validate').addEventListener('click', async () => {
        const handle = overlay.querySelector('.loyalty-modal__input').value.trim();
        if (!handle) { overlay.querySelector('.loyalty-modal__input').style.borderColor = 'red'; return; }
        overlay.remove();
        const res = await submitAction('share_story', { handle });
        await handleActionResult(res, btn);
      });
    },
  };

  // ── Redeem ────────────────────────────────────────────────────────────────
  document.querySelectorAll('.loyalty-btn--redeem').forEach(btn => {
    btn.addEventListener('click', async () => {
      const rewardId = btn.dataset.rewardId;
      if (!await showConfirmModal({ icon: '🎁', title: 'Confirmer l’échange', text: 'Confirmer l’échange de points contre cette récompense ?', confirmLabel: 'Confirmer' })) return;

      btn.disabled = true;
      btn.textContent = '...';

      const res = await apiFetch('/api/redeem', {
        method: 'POST',
        body: JSON.stringify({ customer_id: customerId, reward_id: rewardId }),
      });
      const data = await res.json();

      if (res.ok) {
        document.getElementById('loyalty-points').textContent = data.remaining_points;
        if (data.mystery) {
          showMessageModal({ icon: '✨', title: `${data.reward_label} en route !`, text: `Euteyia prépare ta sélection de ${data.bijoux} bijoux. Tu recevras ton colis surprise sous 3-5 jours. 💌` });
        } else {
          document.getElementById('loyalty-code-box').textContent = data.code;
          const expiry = data.expires_at ? ` (expire le ${new Date(data.expires_at).toLocaleDateString('fr-FR')})` : '';
          document.getElementById('loyalty-code-hint').textContent = `Copiez ce code et utilisez-le à la caisse.${expiry}`;
          document.getElementById('loyalty-code-result').style.display = '';
        }
        btn.textContent = 'Obtenir';
        btn.disabled = false;
        await loadPastRewards();
        await loadHistory();
      } else {
        showMessageModal({ icon: '⚠️', title: 'Erreur', text: data.error || 'Erreur' });
        btn.textContent = 'Obtenir';
        btn.disabled = false;
      }
    });
  });

  document.querySelectorAll('.loyalty-reward-card--interactive').forEach(card => {
    card.addEventListener('click', (event) => {
      if (event.target.closest('.loyalty-btn--redeem')) return;
      card.querySelector('.loyalty-btn--redeem')?.click();
    });
  });

  document.getElementById('loyalty-code-box')?.addEventListener('click', function () {
    navigator.clipboard.writeText(this.textContent).then(() => {
      const orig = this.textContent;
      this.textContent = '✓ Copié !';
      setTimeout(() => { this.textContent = orig; }, 1500);
    });
  });

  sortGridByPoints('bc-rewards-grid');
  init().catch(console.error);
})();
